import React, { useEffect, useState } from "react";
import "./proposito.css";
import { getStaticUrl } from "../../../../utils/getStaticUrl";

const boxes = [
  {
    id: 1,
    title: "Alianza",
    icon: "icons/nosotras.png",
    icon2: "icons/porotito.png",
    text: "Con el financiamiento de empresas privadas ofrecemos programas de formación gratuitos para mujeres.",
  },
  {
    id: 2,
    title: "Formación",
    icon: "icons/convocatorias.png",
    icon2: "icons/porotito.png",
    text: "Acompañamos y apoyamos a cada mujer durante su formación, asegurando el éxito del programa y sus objetivos.",
  },
  {
    id: 3,
    title: "Impacto",
    icon: "icons/programas.png",
    icon2: "icons/porotito.png",
    text: "Continuamos potenciando a las nuevas maestras a través de nuestras comunidades y medimos el impacto.",
  },
];

const Navegador = () => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setAnimate(true), 50); // slight delay
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <p className="proposito-title">Nuestro Modelo</p>
      <div id="proposito-container">
        {boxes.map((box, index) => (
          <div
            key={box.id}
            className={`proposito-box ${animate ? "fade-in" : ""}`}
            style={{ animationDelay: `${index * 100}ms`, cursor: "pointer" }}
          >
            <div className="proposito-subbox">
              <div>
                <img
                  src={getStaticUrl(box.icon2)}
                  alt={box.title}
                  className="proposito-icon"
                />
                <img src={getStaticUrl(box.icon)} alt={box.title} />
              </div>
              <p>{box.title}</p>
            </div>
            <span>{box.text}</span>
          </div>
        ))}
      </div>
    </>
  );
};

export default Navegador;
